<template>
  <div class="contacts-map" ref="map"/>
</template>

<script>
const DEFAULT_ICON_SIZE = ['45', '58'];
const DEFAULT_ICON_OFFSET = ['-20', '-50'];

const GEO_QUERY_CHECK_ZOOM_RANGE = true;
const GET_QUERY_ZOOM_MARIN = 20;

export default {
  props: {
    hasShowMore: {
      type: Boolean,
      default: true,
    },
    center: {
      type: Array,
      /** Default value -> Moscow */
      default: () => [55.71694627715869, 37.64316549999999]
    },
    zoom: {
      type: String,
      default: '10',
    },
    maxZoom: {
      type: String,
      default: '17',
    },
    minZoom: {
      type: String,
      default: '10',
    },
    controls: {
      type: Array,
      default: () => ['zoomControl', 'typeSelector', 'rulerControl'],
    },
    shops: {
      type: Array,
      default: () => [],
    },
    cluster: {
      type: Object,
      default: () => {
        return {}
      },
    },
    objectManagerConfig: {
      type: Object,
      default: () => {
        return {
          clusterize: true,
          clusterHasBalloon: false,
          geoObjectOpenBalloonOnClick: true,
        }
      }
    },
  },
  data: () => ({
    mapInitialized: false,
  }),
  computed: {
    shopsHash() {
      return this.shops.map((point) => point.id).join();
    },
    mapConfig() {
      return {
        center: this.center,
        zoom: this.zoom,
        controls: this.controls,
        maxZoom: this.maxZoom,
        minZoom: this.minZoom,
      }
    },
    clusterIconLayout() {
      return this.cluster.clusterIconLayout || '<div class="marker_container clusterLayout"><b>{{ properties.geoObjects.length }}</b></div>';
    },
    clusterConfig() {
      return {
        clusterIconLayout: ymaps.templateLayoutFactory.createClass(this.clusterIconLayout),
        iconOffset: this.cluster.iconOffset || [-20, -20],
        clusterIconShape: this.cluster.clusterIconShape || {type: 'Circle', coordinates: [20, 20], radius: 20}
      }
    },
    shopsAsFeatures() {
      return {
        type: "FeatureCollection",
        features: this.shops.map((shop) => {
          const dateReOpenInfo = this.createDateReopen(shop);
          const subwayInfo = this.createSubwayInfo(shop);
          const phone = this.createPhone(shop);

          const extra = this.hasShowMore
              ? `<a href="javascript:void(0)" onClick="$('#shop-${shop.id}').click()">${BX.message('KZ_COMPONENTS_DETAILS')}</a>`
              : '';

          return {
            id: shop.id,
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: shop.coords.split(','),
            },
            properties: {
              hintContent: shop.name,
              balloonContent: `
                  <div class="shop_title">${shop.name}</div>
                  ${subwayInfo}
                  <div class="shop_adress">${shop.address}</div>
                  <div>
                      <span class="shop_phone"><a href="tel:${phone}">${phone}</a>    </span>
                      <span class="shop_working_hours">${shop.workingTime}</span>
                      <br/>
                      ${dateReOpenInfo}
                      ${extra}
                  </div>
                `,
            },
            options: {
              iconLayout: 'default#image',
              iconImageHref: this.createMapIcon(shop),
            },
          }
        }),
      };
    },
  },
  methods: {
    /** @todo create a separate layer for that */
    createPhone({phoneExt, phone}) {
      return phoneExt
          ? `${phone} (доб. ${phoneExt})`
          : phone;
    },
    createSubwayInfo({metroName}) {
      return metroName
          ? `<div class="shop_subway"'>${metroName}</div>`
          : ''
    },
    createDateReopen({dateReOpen}) {
      return dateReOpen
          ? `<div class="closed-recostruction">
                  <span>Закрыт на реконструкцию</span>
                  <br>
                  <span>Дата открытия: ${dateReOpen}</span>
                </div>`
          : ''
    },
    createMapIcon({mapIconStyle}) {
      switch (mapIconStyle) {
        case 'kanzler_new':
          return '/local/images/icons/kanzler-new-marker.png';
        case 'kanzler_rek':
          return '/local/images/icons/kanzler-rek-marker.png';
        default:
          return '/local/images/icons/map_marker.png';
      }
    },
    appendShopsAsPlacemarks() {
      this.objectManager.clusters.options.set(this.clusterConfig)
      this.objectManager.add(this.shopsAsFeatures);

      ymaps
          .geoQuery(this.shopsAsFeatures)
          .applyBoundsToMap(
              this.map,
              {checkZoomRange: GEO_QUERY_CHECK_ZOOM_RANGE, zoomMargin: GET_QUERY_ZOOM_MARIN}
          );
    }
  },
  mounted() {
    ymaps.ready(() => {
      this.map = new ymaps.Map(this.$refs['map'], this.mapConfig);
      this.map.behaviors.enable('scrollZoom');
      this.objectManager = new ymaps.ObjectManager(this.objectManagerConfig)

      this.appendShopsAsPlacemarks();

      this.map.geoObjects.add(this.objectManager);

      this.mapInitialized = true;
    });
  },
  watch: {
    shopsHash() {
      if (this.mapInitialized) {
        this.appendShopsAsPlacemarks();
      }
    },
  },
  beforeDestroy() {
    this.map.destroy();
  },
}
</script>
